import React, { useEffect, useState } from 'react';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import {
  getShipments,
  generateAndSendBulkRateConfirmation,
} from '../../../utils/ShipmentWebAPIUtils';

function BulkGenerateRateConfirmation({
  showModal,
  selectedShipments,
  onHide,
  t,
}) {
  const [shipments, setShipments] = useState([]);
  const [emailAddresses, setEmailAddresses] = useState({});
  async function fetchShipments() {
    const result = await getShipments({ _id: selectedShipments });
    setShipments(result?.entity?.items);
  }

  useEffect(() => {
    fetchShipments();
  }, [selectedShipments]);

  function generatePayload() {
    return Object.keys(emailAddresses).map((jobId) => {
      return {
        jobId,
        addresses: emailAddresses[jobId].split(','),
      };
    });
  }

  function handleSave() {
    generateAndSendBulkRateConfirmation(generatePayload());
    handleClose();
  }

  function handleApplyBelow(currentIndex) {
    const currentShipment = shipments[currentIndex];
    const currentValue = emailAddresses[currentShipment._id];
    const updates = Array(shipments.length - currentIndex)
      .fill()
      .reduce((currentData, _currentValue, index) => {
        const shipment = shipments[currentIndex + index];
        currentData[shipment._id] = currentValue;
        return currentData;
      }, {});
    setEmailAddresses((prevState) => {
      return {
        ...prevState,
        ...updates,
      };
    });
  }

  function handleRemoveShipment(shipmentId) {
    setShipments((currentState) => {
      return currentState.filter((shipment) => shipment._id !== shipmentId);
    });
  }

  function handleClose() {
    onHide();
  }

  function getFooter() {
    return (
      <div className="flex justify-end button-group">
        <button className="block button secondary-action" onClick={handleClose}>
          {titleize(t('CLOSE'))}
        </button>
        <button
          className="button button-green flex items-center"
          disabled={false}
          onClick={handleSave}
        >
          <span>{t('SEND_ALL')}</span>
        </button>
      </div>
    );
  }

  function getBody() {
    const rows = shipments.map((shipment, index) => {
      return (
        <tr>
          <td>{shipment.shipment_id}</td>
          <td>
            <CargomaticInput
              type="text"
              name={t('EMAIL')}
              placeholder={t('EMAIL_ADDRESS')}
              className="mb-4"
              value={emailAddresses[shipment._id]}
              onChange={(value) => {
                setEmailAddresses((currentEmails) => {
                  return {
                    ...currentEmails,
                    [shipment._id]: value,
                  };
                });
              }}
            />
          </td>
          <td>
            <button
              className="button button-hollow-green ml-8"
              type="button"
              onClick={() => handleApplyBelow(index)}
            >
              {titleize(t('APPLY'))}
            </button>
          </td>
          <td>
            <button
              className="button text-grey-dark hover:text-grey-darker"
              onClick={() => handleRemoveShipment(shipment._id)}
            >
              <i className="fa fa-remove" />
            </button>
          </td>
        </tr>
      );
    });
    return (
      <div
        className="p-4 bg-gray-100 overflow-y-auto"
        style={{ maxHeight: '80vh' }}
      >
        <table className="min-w-full">
          <thead>
            <tr>
              <td className="text-sm uppercase text-gray-500">
                {titleize(t('SHIPMENT', { count: 1 }))}
              </td>
              <td className="text-sm uppercase text-gray-500">
                {titleize(t('EMAIL'))}
              </td>
              <td>
                <span className="ml-8 uppercase text-sm text-gray-500">
                  {titleize(t('APPLY_BELOW'))}
                </span>
              </td>
              <td className="text-sm uppercase text-gray-500">
                {titleize(t('REMOVE'))}
              </td>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }
  return (
    <CargomaticModal
      dialogClassName="modal-override-medium"
      title={t('SEND_RATE_CONFIRMATION')}
      style={{ top: '20%' }}
      show={showModal}
      onHide={handleClose}
      body={getBody()}
      footer={getFooter()}
    />
  );
}

export default withTranslation()(BulkGenerateRateConfirmation);
